<!--
	Copyright (c) 2021-present, Bäumer, Afonso, Meissner GmbH
	All rights reserved.
-->
<script setup>
import {
    useCssVar,
    useResizeObserver,
    useWindowScroll,
    useScroll,
    // useScrollLock,
} from "@vueuse/core";
import { computed, onBeforeUnmount, ref, watch, toRefs } from "vue";

const SCROLL_THRESHOLD = 100;

const el = ref(null);
const wasScrollingUp = ref(false);
const navigationVisible = ref(false);
const searchVisible = ref(false);
const swiper = ref(null);
const { y } = useWindowScroll();
const { directions, arrivedState } = useScroll(window);
const { top: atTop } = toRefs(arrivedState);

// const isScrollLocked = useScrollLock(window.document.documentElement);

const visible = computed(() => {
    return atTop.value || y.value < SCROLL_THRESHOLD || wasScrollingUp.value;
});

const headerHeight = useCssVar(
    "--bam-header-height",
    ref(document.documentElement)
);

const { stop } = useResizeObserver(el, (entries) => {
    const entry = entries[0];
    const { blockSize: height } = entry.borderBoxSize[0];
    headerHeight.value = `${height}px`;
});

const toggleNavigation = () => {
    navigationVisible.value = !navigationVisible.value;
    // isScrollLocked.value = true;
};

const showNavigation = () => {
    navigationVisible.value = true;
    // isScrollLocked.value = true;
};

const hideNavigation = () => {
    navigationVisible.value = false;
    // isScrollLocked.value = false;
};

const setSwiper = (swpr) => {
    swiper.value = swpr;
};

const toggleSearch = () => {
    searchVisible.value = !searchVisible.value;
};

watch(
    [headerHeight],
    ([height]) => {
        headerHeight.value = height;
    },
    { immediate: true }
);

watch(directions, (newDirections) => {
    if (newDirections.top && !newDirections.bottom) {
        wasScrollingUp.value = true;
    } else if (newDirections.bottom) {
        wasScrollingUp.value = false;
    }
});

onBeforeUnmount(() => {
    stop();
    // isScrollLocked.value = false;
});
</script>

<template>
    <header
        :class="{
            'the-header': true,
            'the-header--shrunk': y > SCROLL_THRESHOLD,
            'the-header--invisible':
                !navigationVisible &&
                !atTop &&
                y > SCROLL_THRESHOLD &&
                !wasScrollingUp,
        }"
        ref="el"
        id="the-header"
    >
        <slot
            v-bind="{
                navigationVisible,
                showNavigation,
                hideNavigation,
                toggleNavigation,
                searchVisible,
                setSwiper,
                toggleSearch,
            }"
        />
    </header>
</template>
